module.exports = __webpack_public_path__ + "doctor-blue.png?17b2fd2bf76fa92c230791aa38f4fd60";


//////////////////
// WEBPACK FOOTER
// ./images/doctor-blue.png
// module id = 167
// module chunks = 0